import jsPDF from "jspdf";
import * as htmlToImage from "html-to-image";

export async function exportMultipleChartsToPdf() {
  const doc = new jsPDF("p", "px");

  const elements = document.querySelectorAll(".pdf-rendering");
  const title = document.getElementsByClassName("website-title");
  const distribution = document.getElementsByClassName("button-is-active");
  const target = document.getElementsByClassName("table-target-title-bold-text");
  await createPdf({ title, distribution, doc, elements });

  doc.save(`Silvagris_${distribution[0].textContent}_${target[0].textContent}.pdf`);
}

async function createPdf({
  title,
  distribution,
  target,
  doc,
  elements,
}) {
   
  const padding = 10;
  const marginTop = 35;
  let top = marginTop;
  doc.setFontSize(10);
       doc.text(15, 15, title[0].textContent) ;
       doc.text(15, 25, distribution[0].textContent) ;
  

  for (let i = 0; i < elements.length; i++) {
    
  const el = elements.item(i);
  console.log("element item");
  console.log(el.offsetHeight);
  console.log(elements.item(i));
  if(el.offsetHeight !== 0) {
  const imgData = await htmlToImage.toPng(el);
   
    let elHeight = el.offsetHeight;
    let elWidth = el.offsetWidth;

    const pageWidth = doc.internal.pageSize.getWidth();

    if (elWidth > pageWidth) {
      const ratio = pageWidth / elWidth;
      elHeight = elHeight * ratio - padding * 2;
      elWidth = elWidth * ratio - padding * 2;
    }

    const pageHeight = doc.internal.pageSize.getHeight();

    if (top + elHeight > pageHeight) {
      doc.addPage();
      top = marginTop;
    }

    doc.addImage(imgData, "PNG", padding, top, elWidth, elHeight, `image${i}`);
    top += elHeight + marginTop;

  }
  }
}